import { render, staticRenderFns } from "./more-information.component.vue?vue&type=template&id=342ce626&"
import script from "./more-information.component.ts?vue&type=script&lang=ts&"
export * from "./more-information.component.ts?vue&type=script&lang=ts&"
import style0 from "./more-information.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports